import React, { useEffect } from "react";
import { useHistory } from "react-router";
import * as actions from "./store/actions";
import { useSelector, useDispatch } from "react-redux";
import styled, { ThemeProvider } from "styled-components";
import { ThemeA, ThemeB, ThemeDrife } from "./styles/theme";

import Header from "./components/Header/Header";
import Footer from "./components/Footer"
import Modal from "./components/styled/Modal/Modal";
import Button from "./components/styled/Button/Button";
import { showWalletModal } from "./store/actions/globalActions";
import { Switch, Route } from "react-router-dom";
import PoolCard from "./components/Pool/PoolCard";
import BigNumber from 'bignumber.js';
import { RefreshContextProvider } from './context/RefreshContext';
import { ToastContainer, toast } from "react-toastify";
import "./App.css";
import 'bootstrap/dist/css/bootstrap.min.css';

BigNumber.config({
  EXPONENTIAL_AT: 1000,
  DECIMAL_PLACES: 80,
})

toast.configure(
  {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true
  }
)

const WrapperStyled = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: ${(props) => props.theme.palette.common.mainBackground};
`;

function App() {
  const { walletModal } = useSelector((state) => state.global);
  const globalState = useSelector((store) => store.global);
  const { projectNamePoolName } = useSelector((state) => state.global);

  const {
    error,
    errorMsg,
    errorTitle,
    errorBtnLabel,
    currentChainId,
    errorCallback,
  } = globalState;

  const dispatch = useDispatch();

  const history = useHistory();

  const toggleErrorModal = (_, okClicked) => {
    if (okClicked && error?.code?.toString() === "4001") {
      dispatch(showWalletModal());
    }
    dispatch(
      actions.setError(null, {
        errorMsg: "",
        errorTitle: "",
        errorBtnLabel: "",
        errorCallback: null,
      })
    );
  };

  useEffect(() => {
    // registering event listener for metamask account change
    if (window.ethereum) {
      window.ethereum.on("accountsChanged", () => {
        // dispatch(actions.logout(token, history));
        window.location.reload();
      });
      window.ethereum.on("chainChanged", (chainId) => {
        // dispatch(actions.updateAccountDetailsOnChainChange(chainId));
        window.location.reload();
      });
    }
  }, [dispatch, history]);

  // update current chain id when the app first renders
  useEffect(() => {
    dispatch(actions.updateChainId());
  }, [dispatch]);

  const getBtnProps = (code) =>
    code === 0 && {
      as: "a",
      target: "_blank",
      href: "https://metamask.io/",
      className: "color-primary",
    };

  return (
    <>
      <ThemeProvider
        theme={projectNamePoolName?.pool_theme || ThemeA}
      >
        <RefreshContextProvider>
          <WrapperStyled>
            <ToastContainer />
            <Header
              hasMetamask={globalState.hasMetamask}
              showWalletList={walletModal?.show}
              currentChainId={currentChainId}
            />
            <Modal
              show={!!error}
              onHide={toggleErrorModal}
              centered
              width={error?.code === 10 ? "40rem" : "30rem"}
            >
              <h3 className="py-3 mb-2 title2">{errorTitle}</h3>
              <p className="text1">{errorMsg}</p>
              <Button
                color="secondary"
                className="mt-4"
                type="button"
                onClick={(e) => {
                  toggleErrorModal(e, true);
                  errorCallback && errorCallback();
                }}
                $width="100%"
                size="lg"
                {...getBtnProps(error?.code)}
              >
                {errorBtnLabel || "Ok"}
              </Button>
            </Modal>
            <Switch>
              <Route exact path="/">
                <PoolCard />
              </Route>
              <Route exact path="/:network">
                <PoolCard />
              </Route>
              <Route path="/:network/:corePoolAddress">
                <PoolCard />
              </Route>
            </Switch>
            <Footer></Footer>
          </WrapperStyled>
        </RefreshContextProvider>
      </ThemeProvider>
    </>
  );
}

export default App;
